import { INavData } from '@coreui/angular';
import { environment } from 'environments/environment';

interface NavAttributes {
  [propName: string]: any;
}
interface NavWrapper {
  attributes: NavAttributes;
  element: string;
}
interface NavBadge {
  text: string;
  variant: string;
}
interface NavLabel {
  class?: string;
  variant: string;
}

export interface NavData {
  name?: string;
  url?: string;
  icon?: string;
  badge?: NavBadge;
  title?: boolean;
  children?: NavData[];
  variant?: string;
  attributes?: NavAttributes;
  divider?: boolean;
  class?: string;
  label?: NavLabel;
  wrapper?: NavWrapper;
}

export var navItems: INavData[] = [
  { name: 'Products & Inventory', url: '/products', icon: 'bi bi-box-seam' },
  {
    name: 'Dashboard',
    url: '/home',
    icon: 'icon-speedometer'
  },
  {
    name: 'Leads',
    url: '/leads',
    icon: 'bi bi-person-lines-fill',
    children: [
      {
        name: 'Active Leads',
        url: '/leads/all-leads',
        icon: 'bi bi-people-fill'
      },
      {
        name: 'Already Worked Leads',
        url: '/leads/inactive-leads',
        icon: 'bi bi-person-dash'
      },
      {
        name: 'Businesses',
        url: '/leads/businesses',
        icon: 'bi bi-building'
      },
      {
        name: 'Documents',
        url: '/leads/documents',
        icon: 'bi bi-folder'
      },
      {
        name: 'Lists',
        url: '/leads/lists',
        icon: 'bi bi-card-list'
      },
      {
        name: 'Bulk Add',
        url: '/leads/bulk-add-leads',
        icon: 'bi bi-file-earmark-excel-fill'
      },
      {
        name: 'Distribute',
        url: '/leads/distributions',
        icon: 'bi bi-shuffle'
      },
      {
        name: 'Leads from Email',
        url: '/leads/mailbox',
        icon: 'bi bi-envelope'
      }
    ]
  },
  {
    name: 'Engagements',
    url: '/engagements',
    icon: 'bi bi-arrow-left-right',
    children: [
      {
        name: 'All Engagements',
        url: '/engagements/all-engagements',
        icon: 'bi bi-arrow-left-right'
      },
      {
        name: 'Calls',
        url: '/engagements/calls',
        icon: 'bi bi-telephone-fill'
      },
      {
        name: 'Messages',
        url: '/engagements/messages',
        icon: 'bi bi-envelope-fill'
      },
      {
        name: 'Visits',
        url: '/engagements/visits',
        icon: 'bi bi-geo-alt-fill'
      },
      {
        name: 'Tasks',
        url: '/todo/grid',
        icon: 'bi bi-list-task'
      },
      // {
      //   name: 'Campaigns',
      //   url: '/engagements/campaigns',
      //   icon: 'bi bi-megaphone-fill'
      // }
    ]
  },
  {
    divider: true
  },
  {
    name: 'To Do',
    url: '/todo/to-do-kanban',
    icon: 'bi bi-list-task'
  },
  {
    divider: true
  },
  {
    name: 'Opportunities',
    url: '/opportunities/opportunity-list',
    icon: 'bi bi-currency-dollar',
    children: [
      {
        name: 'Deals',
        icon: 'fa fa-handshake-o',
        url : "/opportunities/opportunity-list"
      },
      {
        name: 'Payments',
        icon: 'bi bi-currency-dollar',
        url : "/opportunities/payments"
      }
    ]
  },
  {
    divider: true
  },
  {
    name: 'Metrics',
    url: '/metrics',
    icon: 'fa fa-line-chart',
    badge: {
      variant: 'info',
      text: 'NEW'
    },
    children: [
      // {
      //   name: 'Charts',
      //   icon: 'bi bi-pie-chart-fill',
      //   url : ['/metrics', {outlets: {'metric': ['chart']}}],
      //   linkProps : {routerLinkActiveOptions : {exact : true}}
      // },
      {
        name: 'Activity Metrics',
        icon: 'bi bi-graph-up',
        url : "/metrics/performance",
        linkProps : {routerLinkActiveOptions : {exact : true}}
      },
      {
        name: 'User Leads',
        icon: 'fa fa-user',
        url : "/metrics/user-lead-report"
      },
      {
        name: 'Source Reports',
        icon: 'fa fa-database',
        url : "/metrics/source-report"
      },
      {
        name: 'Custom Reports',
        icon: 'bi bi-pie-chart-fill',
        url : "/metrics/custom-report"
      },
      {
        name: 'Attendance Metrics',
        icon: 'bi bi-hand-index',
        url : "/metrics/attendance"
      },
      // {
      //   name: 'Call Metrics',
      //   url: ['/metrics', {outlets: {'metric': ['calling']}}],
      //   icon: 'bi bi-telephone-fill',
      //   linkProps : {routerLinkActiveOptions : {exact : true}}
      // },
    ]
  },
  {
    divider: true
  },
  {
    name: 'Activities',
    url: '/activities/activities-feed',
    icon: 'icon-chart'
  },
  {
    divider: true
  },
  {
    name: 'Live Location',
    url: '/location',
    icon: 'icon-location-pin'
  },
  {
    divider: true
  },
  {
    name: 'Data Exports',
    url: '/export',
    icon: 'bi bi-cloud-arrow-down-fill'
  },
  {
    name: 'Conversations',
    url: '/conversations',
    icon: 'fa fa-comments',
    badge: {
      variant: 'info',
      text: 'NEW'
    },
    children: [
      {
        name: 'Lead Inbox',
        url: '/conversations/inbox',
        icon: 'bi bi-chat'
      },
      {
        name: 'Team Inbox',
        url: '/conversations/team-inbox',
        icon: 'bi bi-chat-left-fill'
      },
      {
        name: 'Broadcasts',
        url: '/conversations/broadcast',
        icon: 'bi bi-broadcast'
      },
      {
        name: 'Auto-Messaging',
        url: '/conversations/reply',
        icon: 'bi bi-reply-all'
      },
      // {
      //   name: 'Sequence',
      //   url: '/conversations/sequence',
      //   icon: 'bi bi-sliders'
      // },
      {
        name: 'AI Chatbot',
        url: '/conversations/chatbot',
        icon: 'bi bi-magic'
      },
      {
        name: 'Tickets',
        url: '/conversations/tickets',
        icon: 'bi bi-ticket-detailed'
      },
      {
        name: 'Conversation Stats',
        url: '/conversations/stats',
        icon: 'bi bi-sliders'
      }
    ]
  },
  {
    name: 'Chat With Us',
    url: '/start-support-chat',
    icon: 'bi bi-question-circle-fill',
    class: 'wa-support'
  },
];

// export const navItems: INavData[] = [
//   {
//     name: 'Dashboard',
//     url: '/dashboard',
//     icon: 'icon-speedometer',
//     badge: {
//       variant: 'info',
//       text: ''
//     },
//   },
//   {
//     title: true,
//     name: 'To-Do : Calls',
//   },
//   {
//     name: 'Scheduled',
//     url: "['todo/todo', {outlets: {'to-do': ['scheduled-calls']}}]",
//     href : "/todo/todo/(to-do:scheduled-calls)",
//     icon: 'icon-hourglass',
//     badge: {
//       variant: 'success',
//       text: '5'
//     }
//   },
//   {
//     name: 'Unreturned',
//     url: "['todo/todo', {outlets: {'to-do': ['never-returned-calls']}}]",
//     href : "/todo/todo/(to-do:never-returned-calls)",
//     icon: 'icon-pencil',
//     badge: {
//       variant: 'success',
//       text: '3'
//     }
//   },
//   {
//     name: 'No Outcome',
//     url: "['todo/todo', {outlets: {'to-do': ['calls-without-outcome']}}]",
//     href : "#/todo/todo/(to-do:calls-without-outcome)",
//     icon: 'fa fa-phone',
//     badge: {
//       variant: 'success',
//       text: '3'
//     }
//   },
//   {
//     title: true,
//     name: 'To-Do : Contacts',
//   },
//   {
//     name: 'Unsaved',
//     url: "['todo/todo', {outlets: {'to-do': ['unsaved-contacts']}}]",
//     href : "#/todo/todo/(to-do:unsaved-contacts)",
//     icon: 'icon-pencil',
//     badge: {
//       variant: 'success',
//       text: '3'
//     }
//   },
//   {
//     name: 'Uncontacted',
//     url: "['todo/todo', {outlets: {'to-do': ['never-contacted']}}]",
//     href : "#/todo/todo/(to-do:never-contacted)",
//     icon: 'icon-pencil',
//     badge: {
//       variant: 'success',
//       text: '3'
//     }
//   },
//   {
//     title: true,
//     name: 'To-Do : Meetings',
//   },
//   {
//     name: 'Scheduled',
//     url: "['todo/todo', {outlets: {'to-do': ['scheduled-meetings']}}]",
//     href : "#/todo/todo/(to-do:scheduled-meetings)",
//     icon: 'icon-pencil',
//     badge: {
//       variant: 'success',
//       text: '3'
//     }
//   },
//   {
//     name: 'Unlogged',
//     url: "['todo/todo', {outlets: {'to-do': ['unlogged-meetings']}}]",
//     href : "#/todo/todo/(to-do:unlogged-meetings)",
//     icon: 'icon-pencil',
//     badge: {
//       variant: 'success',
//       text: '3'
//     }
//   }
// ];
